<template>
  <div class='content'>
    <div class="top">
      <img src="@static/images/personal/exit.png" class="exit-btn" @click="exitWeb">
      <div class="top-img">
        <div class="user">
          <img v-if="userInfo.image" :src="userInfo.image" class="user-img" alt="">
          <img v-else src="@static/images/personal/user-icon.jpg" class="user-img" alt="">
        </div>
        <div class="user-name">{{userInfo.name}}</div>
      </div>
      <div class="categories-tab">
        <div class="categories" @click="$router.push('/m/order')">
          <img class="icons" src="@static/images/personal/tbd.png" alt="">
          <div class="desc">我的投保单</div>
        </div>
        <div class="categories" @click="$router.push('/m/order/rhList')">
          <img class="icons"  src="@static/images/personal/rhd.png" alt="">
          <div class="desc">我的人核单</div>
        </div>
        <div class="categories" @click="$router.push('/m/order/renewList')">
          <img class="icons" src="@static/images/personal/xbd.png" alt="">
          <div class="desc">续保管理</div>
        </div>
      </div>
      <div class="body">
        <div class="title">服务与工具</div>
        <div class="body-content">
          <div class="cate" @click="$router.push('/m/order/visitList')">
            <img class="cate-icon" src="@static/images/personal/dhfbd.png" alt="">
            <div class="cate-desc">待回执回访保单</div>
          </div>
          <div class="cate" v-if="disabled">
            <img class="cate-icon" src="@static/images/personal/cfbd.png" alt="">
            <div class="cate-desc">财富保单</div>
          </div>
          <div class="cate" v-if="disabled">
            <img class="cate-icon" src="@static/images/personal/zjhcbd.png" alt="">
            <div class="cate-desc">证件号查保单</div>
          </div>
          <div class="cate" v-if="disabled">
            <img class="cate-icon" src="@static/images/personal/bdyz.png" alt="">
            <div class="cate-desc">保单验真</div>
          </div>
          <div class="cate" @click="$router.push('/m/order/policyDownload')">
            <img class="cate-icon" src="@static/images/personal/ddbdxz.png" alt="">
            <div class="cate-desc">保单下载</div>
          </div>
          <div class="cate" @click="$router.push('/m/order/importOutsideOrderList')">
            <img class="cate-icon" src="@static/images/personal/lrbd1.png" alt="">
            <div class="cate-desc">录入其它保单</div>
          </div>
          <div class="cate" @click="$router.push('/m/order/importOrderList')">
            <img class="cate-icon" src="@static/images/personal/lrbd2.png" alt="">
            <div class="cate-desc">关联平台保单</div>
          </div>
          <div class="cate" v-if="disabled">
            <img class="cate-icon" src="@static/images/personal/zzbdsq.png" alt="">
            <div class="cate-desc">纸质保单申请</div>
          </div>
          <div class="cate" v-if="disabled">
            <img class="cate-icon" src="@static/images/personal/sqtb.png" alt="">
            <div class="cate-desc">申请退保</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="title">理赔服务</div>
        <div class="body-content">
          <div class="cate" @click="$router.push('/m/applyInfo')">
            <img class="cate-icon" src="@static/images/personal/sqlp.png" alt="">
            <div class="cate-desc">申请理赔</div>
          </div>
          <div class="cate" @click="$router.push('/m/applyInfo/myClaims')">
            <img class="cate-icon" src="@static/images/personal/lpjdcx.png" alt="">
            <div class="cate-desc">理赔进度查询</div>
          </div>
        </div>
      </div>
    </div>
    <!-- <authBtn text="为了保护您的信息隐私安全，使用个人中心功能需要您授权获取微信昵称、头像进行登录，感谢您的支持与配合！"></authBtn> -->
  </div>
</template>
<script>
import common from "@/api/common"
import tools from "@/api/tools"
import authBtn from "@/components/authBtn"
export default {
  data:()=>({
    userInfo:'',
    disabled:false,//隐藏当前版本未做功能
  }),
  components:{
    authBtn
  },
  beforeCreate(){
    if(!localStorage.token) {
      location.replace("/m/login");
      return;
    }
  },
  created(){
    if(localStorage.user){
      const userInfo = JSON.parse(localStorage.user);
      if(this.$route.query.name){
        localStorage.userName = this.$route.query.name
      }
      if(localStorage.userName){
        userInfo.name = localStorage.userName
      }
      if(this.$route.query.image){
        localStorage.userImage = this.$route.query.image;
      }
      if(localStorage.userImage){
        userInfo.image = localStorage.userImage;
      }
      this.userInfo = userInfo;
      localStorage.user = JSON.stringify(userInfo);
      if(this.$route.query.image||this.$route.query.name){
        this.updateUserinfo(userInfo)
      }
    }
    this.$weixin.hideMenu();
  },
  methods:{
    // 退出
    exitWeb(){
      this.$notice.inquiry("确定退出登录？",["确定","取消"],()=>{
        this.$http({
          type: "PUT",
          url: "/api/bplat/loginOut",
          data: {}
        }).then(res=>{
          localStorage.token = "";
          sessionStorage.loginPage = location.href;
          location.replace("/m/login");
        })
      });
    },
    updateUserinfo(userInfo){
      this.$http({
        type: "PUT",
        url: "/api/policyManager/updateUserBaseInfo",
        data: {
          name: userInfo.name,
          image: userInfo.image
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
@import './index';
</style>
